<app-toolbar></app-toolbar>
<app-sidenav></app-sidenav>
<div style="display: none">
  Version {{ buildInfo.version }}, build number {{ buildInfo.build_number }} from revision {{ buildInfo.vcs_ref }} on
  {{ buildInfo.timestamp }}
</div>
